module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Light.c9505072b839823249fbfbf0c3e31ef8.woff2";